import { purchaseDemandItem } from '../../../../../../models/entities/purchaseDemand/purchaseDemandItem';

import { isEmpty } from 'lodash';
import { emptyObject } from './emptyObjects';

export const itemsPrepareSubmit = (values: any, purchaseDemandId?: string) => {
    let items: Array<purchaseDemandItem> = [];
    if (values.items) {
        items = values.items
            .filter((i: purchaseDemandItem) => !!i.productId)
            .map((item: purchaseDemandItem) => {
                return { ...item, purchaseDemandId };
            });
    }
    return items;
};
export const itemsPrepareEdit = (purchaseDemand_items?: Array<purchaseDemandItem>) => {
    let items = purchaseDemand_items;
    if (!items || items.length === 0) items = [];
    return items;
};
export const validateItems = (items: Array<any>, errors: any, localizations: any) => {
    const requiredFieldMessage = localizations.form.requiredFieldMessage;
    const maxLengthMessage = localizations.form.maxLengthMessage;
    if (!errors.items) errors.items = [];
    items.forEach(() => {
        errors.items.push({});
    });
    items.forEach((item, index) => {
        if (!item.quantity) {
            errors.items[index].quantity = requiredFieldMessage;
        }
        if (items.length > 1 && !item.productId) {
            errors.items[index].productId = requiredFieldMessage;
        }
    });
    if (isErrorsEmpty(errors.items)) delete errors.items;
};

// // calculations

export function calcCosts(items: Array<purchaseDemandItem>) {
    const costs = items.reduce((costs: { [key: string]: number }, item: purchaseDemandItem) => {
        const newCosts = { ...costs };
        const { currency, price, quantity } = item;
        if (currency && price && quantity) {
            newCosts[currency] = (newCosts[currency] || 0) + (Number(price) || 0) * (Number(quantity) || 0);
        }
        return newCosts;
    }, {});

    return costs;
}

function isErrorsEmpty(items: Array<any>) {
    for (const item of items) {
        if (!isEmpty(item)) {
            return false;
        }
    }
    return true;
}
export const defaultItems = [emptyObject];
